import {storage, correctedURL} from '../../utilities'
import Projects from '../../DAL/Projects'
import { getDoc, setDoc } from 'firebase/firestore'
import { ref, uploadBytesResumable } from 'firebase/storage'
import { Timestamp } from 'firebase/firestore'

export const submit = (updateStatus, id) => async (files, filePath) => {
  const projects = new Projects()
  const docSnap = await getDoc(projects.docRef(id))

  const statuses = files.map((file) => {
    const fileRef = ref(storage, `${filePath}/${file.name}`)
    return uploadBytesResumable(fileRef, file)
  })

  const addToDoc = {intake: {files: []}}
  const totalCount = statuses.length
  let currentCount = 0
  statuses.forEach((uploadTask) => {
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        const statuses = {
          [uploadTask.snapshot.ref.name]: {
            progress,
            size: snapshot.totalBytes,
          },
        }
        updateStatus && updateStatus({statuses})
      },
      (error) => {
        alert('Something went wrong uploading files to this project')
        console.log(`Something went wrong uploading files to this project`, error)
      },
      async () => {
        let fileMetadata = []

        const {bucket, fullPath, name} = uploadTask.snapshot.ref
        const {totalBytes: size} = uploadTask.snapshot
        const url = correctedURL(fullPath)

        fileMetadata.push({
          bucket,
          fullPath,
          url,
          name,
          size,
          created: Timestamp.now(),
          file_type: 'file',
        })

        let currentStatus = {}
        currentStatus[name] = {
          size: size,
          progress: 100,
        }
        if (updateStatus) {
          updateStatus({statuses: {...currentStatus}})
        }

        addToDoc.intake.files = [...addToDoc.intake.files, ...fileMetadata]

        currentCount++
        if (totalCount === currentCount) {
          addToDoc.intake.files = [...(docSnap.data().intake.files || []), ...addToDoc.intake.files]

          console.log(addToDoc)
          await setDoc(projects.docRef(id), addToDoc, {merge: true})
        }
      }
    )
  })
}
